<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M2 3.91l6.732 4.277.3.19.279-.22 5.729-4.55L22 7.783V20.09l-6.732-4.277-.3-.19-.279.22-5.729 4.55L2 16.217V3.91zM9 8v12.5M15 4v11.5"/>
</svg>
